import {
  actionsKeys,
  permissionActions,
} from "@/lib/utils";
import { setCurrentFinanceYear } from "@/redux/slices";
import { RootState } from "@/redux/store";
import { routes } from "@/routes/utils";
import {
  FileChartColumnIncreasing,
  FileCog,
  RefreshCw,
} from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "@/components/Toast";

const useGeneralLedger = () => {
  const navigate = useNavigate();
  const [openTabs, setOpenTabs] = useState<string[]>(["invoice"]);
  const dispatch = useDispatch();

  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const currentFinanceYear = useSelector(
    (state: RootState) => state.currentData.currentFinanceYear
  );
  const accessPermission = useSelector(
    (state: RootState) => state.currentData.accessPermission
  );

  const [generalLedgerCards, setGeneralLedgerCards] = useState([
    {
      id: "gl-configuration-studio",
      title: "View",
      desc: "GL Configuration Studio",
      icon: FileCog,
      link: `${routes.glConfigurationStudio}`,
      subtitle: "",
      hideCount: true,
      apiKey: "draft",
      module: actionsKeys?.GL_CONFIG?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: "fiscal-year-closing",
      title: "View",
      desc: "Fiscal Year Closing",
      icon: FileChartColumnIncreasing,
      link: `${routes.fiscalYearClosing}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys?.FISCAL_YEAR?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: "fiscal-year-closing-lifecycle",
      title: "View",
      desc: "Fiscal Year Lifecycle",
      icon: RefreshCw,
      link: `${routes.fiscalYearLifeCycle}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys?.FISCAL_YEAR_LIFE_CYCLE?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: "trial-balance",
      title: "View",
      desc: "GL Trial Balance",
      icon: FileChartColumnIncreasing,
      link: `${routes.trialBalance}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys?.GL_TRIAL_BALANCE?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    {
      id: "display-accounting-document",
      title: "View",
      desc: "Display Accounting Document",
      icon: FileChartColumnIncreasing,
      link: `${routes.displayAccountingDocument}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
      module: actionsKeys?.DISPLAY_ACCOUNTING_DOCUMENT?.toLowerCase(),
      accessKeys: permissionActions.READ,
    },
    // {
    //   id: "create-je-manual",
    //   title: "Create",
    //   desc: "Create JE Manual",
    //   icon: FilePen,
    //   link: `${routes.createJEManual}`,
    //   subtitle: "",
    //   hideCount: true,
    //   apiKey: "draft",
    //   module: actionsKeys?.MANUAL_JE?.toLowerCase(),
    //   accessKeys: permissionActions.CREATE,
    // },
    // {
    //   id: "parked-je-manual",
    //   title: "View",
    //   desc: "Parked JE Manual",
    //   icon: FileClockIcon,
    //   link: `${routes.jeManual}/parked`,
    //   subtitle: "",
    //   hideCount: true,
    //   apiKey: "draft",
    //   module: actionsKeys?.MANUAL_JE?.toLowerCase(),
    //   accessKeys: permissionActions.READ,
    // },
    // {
    //   id: "posted-je-manual",
    //   title: "View",
    //   desc: "Posted JE Manual",
    //   icon: FileCheck2,
    //   link: `${routes.jeManual}/posted`,
    //   subtitle: "",
    //   hideCount: true,
    //   apiKey: "draft",
    //   module: actionsKeys?.MANUAL_JE?.toLowerCase(),
    //   accessKeys: permissionActions.READ,
    // },
  ]);

  const breadcrumbData = useMemo(
    () => [
      {
        link: `/${routes.bom}/${routes.finance}`,
        name: `Activity Dashboard`,
      },
      {
        link: "",
        name: <span className="text-primary">{"General Ledger"}</span>,
      },
    ],
    []
  );

    useEffect(() => {
      if (accessPermission) {
        const updatedCards = generalLedgerCards?.map((card: any) => ({
          ...card,
          access: !!accessPermission[card.module]?.[card.accessKeys],
        }));
    
        setGeneralLedgerCards(updatedCards);
      }
    }, [accessPermission]);

  const onYearChange = (e: any) => {
    dispatch(setCurrentFinanceYear(e));
  };

  const onAccordionChange = (e: any) => {
    setOpenTabs(e);
  };

  const onExpandCollapse = () => {
    if (openTabs?.length) {
      setOpenTabs([]);
    } else {
      setOpenTabs(["payment", "invoice"]);
    }
  };

  const onCreateCardClick = (link: string) => () => {
    if (communityData) {
      navigate(link);
    } else {
      toast.error("Please select community");
    }
  };

  const onCardClick = (link: string) => () => {
    navigate(link);
  };

  const onBackClick = () => {
    navigate(`/${routes.bom}/${routes.finance}`);
  };

  return {
    communityData,
    currentFinanceYear,
    onYearChange,
    onAccordionChange,
    openTabs,
    onExpandCollapse,
    onCreateCardClick,
    onCardClick,
    breadcrumbData,
    onBackClick,
    generalLedgerCards
  };
};

export default useGeneralLedger;
